import { store } from "./store";
import {
  HIDE_AUTH_ALERT,
  HIDE_ORDER_ALERT,
  LOGOUT,
  SHOW_ERROR_ALERT,
} from "./actions/actionsTypes";

const superagent = require("superagent");
// const prefix = require('superagent-prefix')('/static');

const API_ROOT =
  window.location.host === "nobaar.com"
    ? "https://app.nobaarapp.ir/api"
    : "https://no1.sh.bernet.cloud/api";

// const API_ROOT = 'https://no1.bernetco.ir/api';

const NESHAN_ROOT = "https://api.neshan.org/v1/";

const responseBody = (res) => {
  if (res.statusCode === 401) store.dispatch({ type: LOGOUT });
  if (res.statusCode !== 200) return null;

  return res.body;
};
const handleCatch = (err) => {
  console.log(err);
  return null;
};
let token = null;
const tokenPlugin = (req) => {
  if (token) {
    req.set("authorization", `Bearer ${token}`);
  }
  req.set("Accept", `application/json`);
};

const neshanKey = (req) => {
  req.set("Api-Key", process.env.REACT_APP_NAK);
};

const handleError = (error) => {
  if (!error.status) {
    store.dispatch({
      type: SHOW_ERROR_ALERT,
      message: "خطا در برقراری ارتباط",
    });
    store.dispatch({ type: HIDE_AUTH_ALERT });
    store.dispatch({ type: HIDE_ORDER_ALERT });
  }

  if (error.response && error.response.statusCode === 401)
    store.dispatch({ type: LOGOUT });

  return error;
};

const requests = {
  del: (url) =>
    superagent
      .del(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .on("error", handleError)
      .then(responseBody)
      .catch(handleCatch),
  get: (url) =>
    superagent
      .get(`${API_ROOT}${url}`)
      .use(tokenPlugin)
      .on("error", handleError)
      .then(responseBody)
      .catch(handleCatch),
  put: (url, body) =>
    superagent
      .put(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .on("error", handleError)
      .then(responseBody)
      .catch(handleCatch),
  post: (url, body) =>
    superagent
      .post(`${API_ROOT}${url}`, body)
      .use(tokenPlugin)
      .on("error", handleError)
      .then(responseBody)
      .catch(handleCatch),
  neshanGet: (url) =>
    superagent
      .get(`${NESHAN_ROOT}${url}`)
      .use(neshanKey)
      .on("error", handleError)
      .then(responseBody)
      .catch(handleCatch),
};

const Auth = {
  phone: (phone) => requests.get(`/send_mobile/${phone}`),
  auth: (phone, code, utm_source, google_token) =>
    requests.post(`/send_activeCode`, {
      //   phone: phone,
      mobile: phone,
      active_code: code,
      "g-recaptcha": google_token,
      utm_source: utm_source,
    }),
  boot: () => requests.get("/v3/boot"),
};

const Order = {
  getPrice: (body) => requests.post("/get_price", body),
  checkLocation: (body) =>
    requests.post("/checklocation", { lat: body.lat, long: body.lng }),
  send: (body) => requests.post("/send_order", body),
  checkCoupon: (body) => requests.post("/check_discount_code", body),
  checkReferral: (body) => requests.post("/check_referral_code", body),
  submitOrder: (body) => requests.post("/final_submit", body),
  cancel: (body) => requests.post("/cancel_order", body),
  edit: (body) => requests.post("/get_edit_order_request", body),
  update: (body) => requests.post("/update_order_new", body),
  traffic: (carId) => requests.get(`/day_range/${carId}`),
  checkLocations: (body) => requests.post("/check-locations", body),
  timing: (id) => requests.get(`/timing/${id}`),
  getHeavyItems: () => requests.get(`/v3/heavy_items/available`),
  getHeavyItemsByCity: (lat, long) =>
    requests.get(`/v3/heavy_items/available/?data=${[lat, long]}`),
  getButtonsItemsPrice: (lat, long) =>
    requests.get(`/get_calc_types/?lat=${lat}&long=${long}&platform=webapp`),
};

const Map = {
  reverseGeolocation: (body) =>
    requests.post(`/v3/location/geolocation/reverse/two`, body),
  /**
   * Neshan Search
   * @param term
   */
  search: (term) => requests.get(`/states?term=${term}`),
  /**
   * Mapir Search locations
   * @param data
   */
  newSearch: (data) =>
    requests.get(
      `/map_search?text=${data.text}&lat=${data.lat}&lng=${data.lng}`
    ),
};

const Invoice = {
  bill: (id) => requests.get(`/v3/bill/${id}`),
  billIntercity: (id) => requests.get(`/v3/bill/${id}?intercity=1`),
  getOrder: (id) => requests.get(`/get_order_by_order_id/${id}`),
  checkWallet: (body) => requests.post(`/paymentcheck`, body),
  pay: (body) => requests.post(`/send_to_bank_wallet`, body),
  list: (page = 1) => requests.get(`/v2/orders_list?page=${page}`),
  checkComment: (body) => requests.post("/check_order_comment", body),
  sendComment: (body) => requests.post("/add_rank", body),
  driver: (id) => requests.post("/get_driver_profile", { order_id: id }),
  priceFeedback: (body) => requests.post("/v3/price/feedback", body),
  rate: (body) => requests.post("/v3/comment/add", body),
};

const Profile = {
  get: (id) => requests.get(`/v2/get_user_profile`),
  store: (body) => requests.post(`/send_profile`, body),
};

const Neshan = {
  reverseGeolocation: (props) =>
    requests.neshanGet(
      `search?term=` + props.text + `&lat=${props.lat}&lng=${props.lng}`
    ),
};

const NowrouzGame = {
  checkReferral: () => requests.get("/v3/nowruz/game/check_referral"),
  getLeaderboard: () => requests.get("/v3/nowruz/game/leaderboard"),
  submitReferral: (body) => requests.post("/v3/nowruz/game/referral", body),
  setScore: (body) => requests.post("/v3/nowruz/game/set_score", body),
};

const agent = {
  Auth,
  Order,
  NeshanServices: Map,
  Invoice,
  Profile,
  Neshan,
  Map,
  NowrouzGame,
  setToken: (_token) => {
    token = _token;
  },
};
export default agent;
